// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import queryString from 'query-string';
import Modal from '../../../../elements/Modal/Modal';
import { DEFAULT_COUNTRIES, getLocalizedCountry } from '../../../local-values/utils/countries';
import { domainRedirectMap } from '../../../../server/middleware/redirect';

import style from './CountrySelectModal.scss';
import sky from '../../../../assets/img/select-country-modal/sky.png';
import country from '../../../../assets/img/select-country-modal/country.png';

import type { Location } from '../../../../router';
import type { LocaleState } from '../../duck';
import type { LocalValuesState } from '../../../local-values/duck';
import type { LocalValueCountry } from '../../../local-values/utils/countries';

type Props = {
  +countrySelectModalOpen: boolean;
  +handleClose: () => void;
  +location: Location;
  +locale: LocaleState;
  +localValues: LocalValuesState;
};

export default class CountrySelectModal extends Component<Props> {
  handleClickCountry = (country: string) => {
    const { location, locale, handleClose } = this.props;
    if (locale.domainCountry === country) {
      return handleClose();
    } else {
      /*const locationSearch = queryString.parse(location.search);
      let locationSearchString = queryString.stringify(locationSearch);
      locationSearchString = locationSearchString ? `?${locationSearchString}` : '';
      window.location.href = `${domainRedirectMap[country]}${location.pathname}${locationSearchString}`;*/
      window.location.href = `${domainRedirectMap[country]}${location.pathname}${location.search}`;
    }
  };

  buildOption = (country: LocalValueCountry) => {
    const { localValues } = this.props;
    return (
      <article key={country.key}
               className={style.countryOption}
               onClick={_ => this.handleClickCountry(country.key)}>
        <img src={country.icon} alt={country.key}/>
        <p className={style.countryTitle}>{
          getLocalizedCountry(country.key, this.context.intl.formatMessage, localValues.countriesMap)
        }</p>
      </article>);
  };

  render() {
    const { countrySelectModalOpen, handleClose, localValues } = this.props;
    // Currently we are not supporting US
    const availableCountries = (localValues.countries || DEFAULT_COUNTRIES)
      .filter((country: LocalValueCountry) => country.key !== 'US');
    return (
      <Modal open={countrySelectModalOpen}
             handleClose={handleClose}
             width={544}
             height={580}>
        <section className={style.countrySelectWrap}>
          <img src={sky}
               alt="sky"
               className={style.sky}/>
          <FormattedMessage id="countrySelectModal.title">{
            txt => <h2 className={style.title}>{txt}</h2>
          }</FormattedMessage>
          {availableCountries.map(country => this.buildOption(country))}
          <img src={country}
               alt="country"
               className={style.country}/>
        </section>
      </Modal>
    );
  }
}

CountrySelectModal.propTypes = {
  countrySelectModalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
};

CountrySelectModal.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/locale/components/CountrySelectModal/CountrySelectModal.jsx